export default __webpack_public_path__ + "static/media/DatasetColor.2b56fac1.svg";